import { render, staticRenderFns } from "./sIA.vue?vue&type=template&id=6aff2c55&"
import script from "./sIA.vue?vue&type=script&lang=js&"
export * from "./sIA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports